import React, { PureComponent } from "react";
import Slider from "react-slick";

import { TTP_FORUM_URL } from "Config";
import TopicContainer from "../Topic/TopicContainer";
import FetchingTopicsList from "../Fetching/FetchingTopicsList";
import { slugify } from "Utils";

import _ from "i18n";

export default class TopicsListComponent extends PureComponent {
  renderTopics() {
    const { community, fetching, fetched, topics } = this.props;

    if (fetching) {
      return <FetchingTopicsList />;
    }
    if (!fetched || !topics || topics.length === 0) {
      return null;
    }
    let blocTopic = [];
    for (let i = 0; i < topics.length; i += 4) {
      blocTopic[i / 4] = [];
      for (let j = i; j < Math.min(topics.length, i + 4); j++) {
        blocTopic[i / 4].push(
          <li
            className="cell smal-12 medium-6 large-3"
            key={`topic-container-${topics[j].id}`}
          >
            <TopicContainer topic={topics[j]} community={community} />
          </li>
        );
      }
    }
    const settings = {
      dots: true,
      dotsClass: "slick-dots",
      infinite: true,
      arrows: false,
      speed: 500,
      autoplay: false
    };

    return (
      <div className="section-content">
        <Slider {...settings}>
          {blocTopic.map(bloc => (
            <div className="slick-block" key={Math.random()}>
              <ul className="grid-x">{bloc}</ul>
            </div>
          ))}
        </Slider>
      </div>
    );
  }

  render() {
    const { community, lng, order } = this.props;

    const { hubPreferences } = community;

    let currentBloc = null;
    let title = _("Join the debate");
    let subtitle = _("Take part in our discussion forums");

    if (hubPreferences && hubPreferences.layout_settings) {
      currentBloc = hubPreferences.layout_settings.filter(
        bloc => bloc.order === +order
      );
    }
    if (currentBloc && currentBloc.length > 0) {
      if (
        currentBloc[0][`title${lng.toUpperCase()}`] &&
        currentBloc[0][`title${lng.toUpperCase()}`].length > 0
      ) {
        title = currentBloc[0][`title${lng.toUpperCase()}`];
      }
      if (
        currentBloc[0][`subtitle${lng.toUpperCase()}`] &&
        currentBloc[0][`subtitle${lng.toUpperCase()}`].length > 0
      ) {
        subtitle = currentBloc[0][`subtitle${lng.toUpperCase()}`];
      }
    }

    const comUrl = `${TTP_FORUM_URL}/community/${
      community.url ? community.url : slugify(community.name)
    }/${community.id}`;

    return (
      <section id="new-community-topics">
        <div className="section-body">
          <div className="section-header">
            <div className="section-title">
              <div className="section-title-head">
                <h2>{_("Join the debate")}</h2>
                <a href={comUrl} alt="" className="go-app">
                  {title}
                </a>
              </div>
              <p className="section-title-subhead">{subtitle}</p>
            </div>
            <div className="section-btn">
              <a
                href={comUrl /*TODO Ajout d'une hashtag pour ouvrir l'editeur*/}
                target="_blanc"
                alt=""
                className="btn-action"
              >
                <span>+</span> {_("Post a question")}
              </a>
              <a href={comUrl} target="_blanc" alt="" className="btn-see-more">
                {_("See more")}
              </a>
            </div>
          </div>
          {this.renderTopics()}
        </div>
      </section>
    );
  }
}

// Conn



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/TopicsList/TopicsListComponent.js